import type { Baby, DoseStatus, Facility, Lang, Mother } from '../types';
import type { TFn } from '../i18n';
import { dayDiff, parseDate, startOfToday, toIsoDate } from './dates';

export function isOverdue(i: { status: DoseStatus; date: string }): boolean {
  return i.status === 'missed' || (i.status !== 'attended' && i.date < toIsoDate(startOfToday()));
}

export function durationParts(fromIso: string): { d: number; h: number; m: number } {
  const mins = Math.max(0, Math.floor((Date.now() - new Date(fromIso).getTime()) / 60_000));
  return { d: Math.floor(mins / 1440), h: Math.floor(mins / 60), m: mins % 60 };
}

export function stageLabel(m: Mother, baby: Baby | undefined, t: TFn): string {
  if (m.stage === 'pregnancy' && m.lmp) {
    return t('common.pregnancyWeek', { n: Math.floor(dayDiff(parseDate(m.lmp), new Date()) / 7) });
  }
  if (!baby) return '';
  const days = dayDiff(parseDate(baby.dob), new Date());
  if (days < 7 * 15) return t('common.babyWeeks', { n: Math.floor(days / 7) });
  return t('common.babyMonths', { n: Math.floor(days / 30.4) });
}

export function facilityName(f: Pick<Facility, 'displayNameEn' | 'displayNameHi'>, lang: Lang): string {
  return lang === 'hi' ? f.displayNameHi : f.displayNameEn;
}

export function greetingDoctor(doc?: { title: string; name: string }): string {
  const surname = doc?.name.trim().split(/\s+/).pop();
  return surname ? `${doc?.title} ${surname}` : 'Dr ___';
}

export function initials(name: string): string {
  return name
    .replace(/^Dr\.?\s+/i, '')
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();
}
